import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import Typography from '@mui/material/Typography'
import CloseIcon from '@mui/icons-material/Close'
import { closePopup } from '../../actions/uiActions'
import { getProjects, moveJobToProject, getDbJobsSiteWide } from '../../actions/dbFunctionsActions'

class MoveDbJobToProject extends React.Component {

    state = {
        selectedProjectId: 0,
        projectList: [],
        saveStatus: '',
        saveOperation: ''
    }

    componentDidMount() {
        getProjects()
            .then(json => {
                this.setState({ projectList: json.projectList || [] })
            })
            .catch(ex => {
                console.error('Failed to load projects', ex)
                this.setState({ projectList: [] })
            })
    }

    handleMove = (event) => {
        event.preventDefault()

        if (this.state.selectedProjectId === -1) {
            this.setState({ saveStatus: 'Please select a project.', saveOperation: 'move' })
            return
        }

        const jobId = this.props.popupInfo?.jobData?.id

        this.props.moveJobToProject(jobId, this.state.selectedProjectId)
            .then(() => {
                this.setState({ saveStatus: 'success', saveOperation: 'move' })
                setTimeout(() => {
                    this.props.closePopup()
                }, 2000)
            })
            .catch(ex => {
                console.error('Failed to move job', ex)
                this.setState({ saveStatus: ex.message, saveOperation: 'move' })
            })
    }

    handleClose = (event) => {
        event.preventDefault()
        this.props.closePopup()
    }

    render() {
        const { saveStatus, saveOperation, selectedProjectId, projectList } = this.state
        const jobName = this.props.popupInfo?.jobData?.jobName || 'this job'

        return (
            <Dialog
                open={true}
                onClose={this.handleClose}
                aria-labelledby="move-job-dialog-title"
                aria-describedby="move-job-dialog-description"
            >
                <CloseIcon onClick={this.handleClose} className="closePoup" />
                <DialogTitle id="move-job-dialog-title" className="changepassdialog">
                    Move
                </DialogTitle>
                <DialogContent>
                    <form className="form">
                        <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>
                            Moving Job: <strong>{jobName}</strong>
                        </Typography>
                        <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>
                            Select Project
                        </Typography>
                        <Select
                            className="myInput"
                            value={selectedProjectId}
                            onChange={(e) => this.setState({ selectedProjectId: parseInt(e.target.value), saveStatus: '' })}
                            inputProps={{ 'aria-label': 'Without label' }}
                        >                          
                            {projectList.map(p => (
                                <MenuItem key={p.id} value={p.id}>{p.projectName}</MenuItem>
                            ))}
                        </Select>

                        <br />

                        {saveStatus && (
                            <div style={{
                                color: saveStatus === 'success' ? '#2e7d32' : '#d32f2f',
                                marginTop: '8px',
                                fontSize: '1rem'
                            }}>
                                {saveStatus === 'success'
                                    ? '✓ Job moved successfully.'
                                    : `✗ Failed to move job. ${saveStatus}`}
                            </div>
                        )}

                        <br />
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
                            <button className="btn" type="button" onClick={this.handleClose}>
                                Cancel
                            </button>
                            <button
                                className="btn"
                                type="button"
                                id="save_btn"
                                disabled={selectedProjectId === -1}
                                onClick={this.handleMove}
                            >
                                Move
                            </button>
                        </div>
                    </form>
                </DialogContent>
            </Dialog>
        )
    }
}

function mapStateToProps(state) {
    return {
        popupInfo: state.ui.popupInfo
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators({ closePopup, moveJobToProject }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MoveDbJobToProject)